










import { Component, Vue, Watch } from 'vue-property-decorator';
import { RouterOptions, RouteConfig } from 'vue-router';
import Routes from '@/Routes';
import { Destination } from '@/components/Passenger/models/Destination';

@Component({
  components: {
  },
})
export default class DestinationPage extends Vue {

  noDestinationsError: boolean = false;

  get routeName(){
    return this.$route.name
  }

  get me() {
    return this.$store.state.user.me;
  }

  get destinations(): Destination[] {
    return this.$store.state.destination.destinations;
  }

  get isAuthenticated() {
    return this.$store.getters['auth/isAuthenticated'];
  } 

  get routeDestinationId(): number {
    return parseInt(this.$store.state.route.params.destinationId, 10);
  }
  
  get navigationRoutes(): any[] {
    const topLevelRoutes = (this.$router as any).options.routes;
    const childRoutesArr: any[] = topLevelRoutes.map(r => r.children).filter(r => r);
    const childRoutes = [].concat(...childRoutesArr);
    const allRoutes = topLevelRoutes.concat(childRoutes);
    const navRoutes = allRoutes.filter(r => r.meta && r.meta.nav && (r.meta.guest || this.isAuthenticated));
    return navRoutes;
  }

  get allowedNavigationRoutes(): any[] {
    return this.me 
      ? this.navigationRoutes.filter(r => 
        !r.meta 
        || (r.meta 
          && r.meta.requireDestinationPermissions
          && this.me.hasPermissions(this.routeDestinationId, r.meta.requireDestinationPermissions))
      )
      : []
  }

  async redirectToFirstNavigationRoute(alreadyRedirected: boolean = false){
    if (this.allowedNavigationRoutes[0]){
      if (this.$route.name === Routes.destinationRoute.name){
        this.$router.replace(
          {
            name: this.allowedNavigationRoutes[0].name
          }
        );
      }
    } else {
      if (this.routeDestinationId === 0 && this.destinations.length > 0 && !alreadyRedirected){

        // console.log("WARN", "DestinationPage", "redirectToFirstNavigationRoute", 
        // "this.routeDestinationId is 0, need to redirect ...");

        const firstDestinationId = this.destinations[0].id;

        // console.log("WARN", "DestinationPage", "redirectToFirstNavigationRoute", 
        //  "Redirecting to first destination, with id ", firstDestinationId);

        await this.$router.replace({
            name: Routes.destinationRoute.name,
            params: { 
                destinationId: firstDestinationId.toString(),
            }
        });

        await this.redirectToFirstNavigationRoute(true);

      } else {
        if (this.destinations.length === 0) {
          this.noDestinationsError = true;
          console.error("No destinations available");
        }
      }
    }
  }

  created(){
    this.redirectToFirstNavigationRoute();   
  }

  @Watch('routeName', { immediate: false })
  onRouteNameChanged(val, newVal){
    this.redirectToFirstNavigationRoute();   
  }

};
